import styled from 'styled-components'
import { CollectionItem as BaseCollectionItem, Photo as BasePhoto } from '../Collection'

export const CollectionItem = styled(BaseCollectionItem)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background: #e5e5e5;
  overflow: hidden;
  height: 140px;

  &:hover > a {
    opacity: 1;
  }
`

export const Photo = styled(BasePhoto)``



// WEBPACK FOOTER //
// ./src/components/CollectionProductsSets/theme.js